import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentTagRepository } from '../infra/ShipmentTagRepository'

type GetCarrierShipmentTagsDependencies = {
  repository: ShipmentTagRepository
}

export function getCarrierShipmentTagsFactory({ repository }: GetCarrierShipmentTagsDependencies) {
  return function getTagsImpl(config?: { signal?: AbortSignal }) {
    return repository.fetchCarrierShipmentTags(config)
  }
}

export function getCarrierShipmentTags(config?: { signal?: AbortSignal }) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentTagRepository({ httpClient })
  const get = getCarrierShipmentTagsFactory({ repository })

  return get(config)
}
